import { useEffect } from 'react';
import logo from '../../../../assets/img/png/logo/alea-sidebar-logo.png';
import Sidebar from '../../Sidebar/Siderbar';
import ThumbnailView from './ThumbnailView';
import { useAppSelector } from '../../../../hook/useAppSelector';
import RowDensityMenuMobile from '../../Footer/FooterOption/RowDensityMenuMobile';
import Time from '../../Sidebar/Time/Time';
import ColumnOrder from '../../Header/ColumnOrder/ColumnOrder';
import close from '../../../../assets/img/png/health-monitor/close-button.png';

interface Props {
  animateIn: boolean;
  setAnimateIn: React.Dispatch<React.SetStateAction<boolean>>;
  isMenuButtonActive: boolean;
  onMenuButtonClick: () => void;
}

const MobileMenu: React.FC<Props> = ({ animateIn, setAnimateIn, isMenuButtonActive, onMenuButtonClick }) => {
  const isThumbnailView = useAppSelector((state) => state.configSlice.isThumbnailView);
  const showColumnOrder = useAppSelector((state) => state.globalFilters.showColumnOrder);

  useEffect(() => {
    requestAnimationFrame(() => setAnimateIn(true));
  }, [setAnimateIn]);

  return (
    <div className={`mobile_menu ${animateIn ? 'open' : 'closed'}`}>
      <img className="mobile_logo" src={logo} alt="logo" />
      <button
        className={`menu ${isMenuButtonActive ? 'active' : null} `}
        onClick={() => {
          onMenuButtonClick();
        }}
      >
        <img src={close} alt="menu close" />
      </button>
      <div className="mobile_date_time">
        <Time></Time>
      </div>
      <div className="empty" />
      <div className="mobile_sidebar">
        <Sidebar handleClose={onMenuButtonClick} />
      </div>
      <div className="mobile_table_settings">
        <p>Table settings</p>
        <div className="settings_buttons">
          {showColumnOrder && <ColumnOrder />}
          <ThumbnailView></ThumbnailView>
          {!isThumbnailView && <RowDensityMenuMobile></RowDensityMenuMobile>}
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
